// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import cn from 'classnames';
import './style.scss';
import Chevron_down from '/www/hola/pub/img/svg/icon/chevron_down.svg';
import { Svg } from '/www/hola/pub/ui/svg';
var use_faq = () => {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    set_active = _useState2[1];
  var on_click = n => () => {
    set_active(v => n == v ? null : n);
  };
  return {
    active,
    on_click
  };
};
export var Faq = props => {
  var qa = props.qa,
    client = props.client;
  var on_click = client.on_click,
    active = client.active;
  return /*#__PURE__*/React.createElement("section", {
    className: "hola-faq"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "hola-faq__list",
    onClick: on_click
  }, (qa || []).map(({
    q,
    a
  }, i) => {
    var cls = cn('hola-faq__item', active == i && 'hola-faq__item_opened');
    var handle_click = on_click && on_click(i);
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      className: cls,
      onClick: handle_click
    }, /*#__PURE__*/React.createElement("p", {
      className: "hola-faq__q p1 reg"
    }, q, /*#__PURE__*/React.createElement("button", {
      className: "hola-faq__toggle",
      "aria-label": `Expand question ${q}`
    }, /*#__PURE__*/React.createElement(Svg, {
      icon: /*#__PURE__*/React.createElement(Chevron_down, {
        width: 24,
        height: 24
      })
    }))), /*#__PURE__*/React.createElement("p", {
      className: "hola-faq__a p2 reg",
      dangerouslySetInnerHTML: {
        __html: a
      }
    }));
  })));
};
export var Faq_client = props => {
  var client = use_faq();
  return /*#__PURE__*/React.createElement(Faq, _extends({}, props, {
    client: client
  }));
};
Faq_client.Save = props => {
  return /*#__PURE__*/React.createElement(Faq, _extends({}, props, {
    client: {}
  }));
};